import React from 'react';

import { type LocaleFormat } from 'src/core/common/hooks/useTranslation';

import { AccountRiskAlert } from './components/AccountRiskAlert';
import { AccountSuspensionEffects } from './components/AccountSuspensionEffects';
import { FAQ } from './components/FAQ';
import { FundMyWallet } from './components/FundMyWallet';
import { HeaderText } from './components/HeaderText';
import { OutstandingInvoices } from './components/OutstandingInvoices';
import { type BillingStatus } from './types';

type Props = {
  billingStatus: BillingStatus;
  localeFormat: LocaleFormat;
  companyCurrency: string;
  companyName: string;
};

export const ClosedDoor = ({
  billingStatus,
  localeFormat,
  companyCurrency,
  companyName,
}: Props) => (
  <div className="mx-auto flex max-w-[1500px] flex-col gap-24">
    <AccountRiskAlert />
    <div className="flex gap-24">
      <div className="ContentBlock box">
        <HeaderText
          localeFormat={localeFormat}
          delinquentStartDate={billingStatus.delinquentStartDate}
          overdueInvoices={billingStatus.overdueInvoicesDetails}
          companyCurrency={companyCurrency}
          companyName={companyName}
        />
        <AccountSuspensionEffects />
        <FAQ />
      </div>
      <div className="ContentBlock box min-w-[435px]">
        <OutstandingInvoices
          localeFormat={localeFormat}
          overdueInvoices={billingStatus.overdueInvoicesDetails}
          companyCurrency={companyCurrency}
        />
        <FundMyWallet />
      </div>
    </div>
  </div>
);
